import styled from 'styled-components';
import { media } from '../breakpoints.js';
import { ANALYTICS_KEY } from '../constants.js';
import './Div/index.js';
import { Text } from './Text.js';
import { LinkButton } from './Link/LinkButton.js';
import { StyledInlineLink } from './RichText/components/InlineHyperLink.js';
import { jsx, jsxs } from 'react/jsx-runtime';
import { Div } from './Div/Div.js';
function CTAButtons({
  ctaButtonLabel,
  ctaButtonUrl,
  secondaryButtonLabel,
  secondaryButtonUrl,
  contentBackground = 'background',
  foregroundInlineLink = 'blue60'
}) {
  const isPrimaryBackground = contentBackground === 'primary';
  const primaryButton = ctaButtonLabel && ctaButtonUrl ? /*#__PURE__*/jsx(LinkButton, {
    href: ctaButtonUrl,
    "data-qa": ANALYTICS_KEY.CTAButtonsFirst,
    variant: isPrimaryBackground ? 'secondary' : 'primary',
    children: ctaButtonLabel
  }) : undefined;
  const secondaryButton = secondaryButtonLabel && secondaryButtonUrl ? /*#__PURE__*/jsx(Div, {
    css: {
      display: 'flex',
      alignItems: 'center'
    },
    justifyContent: {
      sm: 'center',
      md: 'flex-start'
    },
    children: /*#__PURE__*/jsx(StyledInlineLink, {
      href: secondaryButtonUrl,
      "data-qa": ANALYTICS_KEY.CTAButtonsSecond,
      $color: foregroundInlineLink,
      children: /*#__PURE__*/jsx(Text, {
        variant: "body",
        children: secondaryButtonLabel
      })
    })
  }) : undefined;
  return primaryButton || secondaryButton ? /*#__PURE__*/jsxs(ButtonsContainer, {
    flexDirection: {
      sm: 'column',
      md: 'row'
    },
    width: {
      sm: '100%',
      md: 'auto'
    },
    spacingTop: 3,
    gap: 3,
    children: [primaryButton, secondaryButton]
  }) : null;
}
const ButtonsContainer = styled(Div)`
  a {
    /* stylelint-disable-next-line declaration-no-important -- Requires testing before removing */
    width: 100% !important;
    text-align: center;
  }

  ${media.md} {
    a {
      width: initial;
    }
  }
`;
export { CTAButtons };
//# sourceMappingURL=CTAButtons.js.map
